import { Space } from 'antd';
import { type PermissionValues } from '../../../utilities/hasPermissions';
import InventoryMainDetailsSection from './InventoryMainDetailsSection';
import InventoryStockSection from './InventoryStockSection';

type InventoryDetailsFormProps = {
    offset?: string;
    disabled?: boolean;
    permissions: Pick<PermissionValues, 'hasDeletePermission'>;
};
const InventoryDetailsForm = ({ offset, disabled = false, permissions }: InventoryDetailsFormProps) => (
    <Space direction="vertical" size={14} style={{ width: '100%' }}>
        <InventoryMainDetailsSection disabled={disabled} offset={offset} />
        <InventoryStockSection permissions={permissions} />
    </Space>
);

export default InventoryDetailsForm;
